import { type ReactNode } from 'react';

import { Tooltip, TooltipContent, TooltipTrigger } from 'components/Display/Tooltip/Tooltip';

import { useListTableCellTruncation } from './useListTableCellTruncation';

type ListTableLongCellProps = {
  children: ReactNode;
  tooltipContent?: ReactNode;
};

export const ListTableLongCell = ({ children, tooltipContent }: ListTableLongCellProps) => {
  const { ref, maxWidth, isTruncated } = useListTableCellTruncation();

  return (
    <Tooltip enabled={isTruncated}>
      <TooltipTrigger>
        <span ref={ref} style={maxWidth ? { maxWidth } : undefined} className="block max-w-xs truncate">
          {children}
        </span>
      </TooltipTrigger>
      <TooltipContent>{tooltipContent ?? children}</TooltipContent>
    </Tooltip>
  );
};
